import { render, staticRenderFns } from "./CandidateItemRFA.vue?vue&type=template&id=3c84e0c6&lang=pug"
import script from "./CandidateItemRFA.vue?vue&type=script&lang=js"
export * from "./CandidateItemRFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports